import { IRoutingBuildSuccessParams, TInfrastructureItem, TTAInfrastructureItem } from '../../../types/map';

export const checkIsInfrastructureRoute = (
  point: TInfrastructureItem | TTAInfrastructureItem,
  params: IRoutingBuildSuccessParams,
) => {
  const wayPointTo = params.wayPoints.find(point => point.index === 1);
  const pointToCoordinates = wayPointTo && wayPointTo.coordinates;

  return (
    !!pointToCoordinates &&
    pointToCoordinates[0] === point.coordinates.lng &&
    pointToCoordinates[1] === point.coordinates.lat
  );
};
